// @flow
import React from 'react';
import styled from 'styled-components';

import dates from 'utils/dates';

const DateWrapper = styled.span`
    &:hover {
        cursor: cell;
    }
`;

export type Props = {
    date: string | Object | Date,
    helpFormat: string,
    suffix: boolean,
};

export const FormattedTimeFromNow = ({
    date,
    helpFormat,
    suffix,
    ...spanProps
}: Props) => {
    return (
        <DateWrapper
            className='date-component'
            title={dates.formatDate(date, helpFormat)}
            {...spanProps}
        >
            {dates.formatRelativeDate(date, suffix)}
        </DateWrapper>
    );
};

FormattedTimeFromNow.defaultProps = {
    helpFormat: 'LLLL',
    suffix: true,
};

export default FormattedTimeFromNow;
